/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-09-14 14:06:13
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2022-12-20 09:41:04
 * @FilePath: \exevnt\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Rain from "../views/rain"
import Typhoon from "../views/typhoon"
import Heat from "../views/heat"
import Dry from "../views/dry"
import Cold from "../views/cold"
import Clime from "../views/clime"
import Sce from "../views/sce"
import Ha from "../views/ha"
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect:'/heat'
    
  },
  {
    path: '/ha',
    name: 'Ha',
    component: Ha
  },
  {
    path: '/sce',
    name: 'Sce',
    component: Sce
  },
  {
    path: '/rain',
    name: 'Rain',
    component: Rain
  },
  {
    path: '/dry',
    name: 'Dry',
    component: Dry
  },
  {
    path: '/typhoon',
    name: 'Typhoon',
    component: Typhoon
  },
  {
    path: '/heat',
    name: 'Heat',
    component: Heat
  },
  {
    path: '/cold',
    name: 'Cold',
    component: Cold
  },
  {
    path: '/clime',
    name: 'Clime',
    component: Clime
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
